import { ColDef } from 'ag-grid-community'

export const AgGridHelper = {
  defaultColumnProperties: {
    suppressMenu: true,
    resizable: true,
    sortable: true,
    flex: 1,
  } satisfies ColDef,
}
